<template>
  <v-dialog v-model="dialog" :max-width="$vuetify.breakpoint.xsOnly ? '' : '600'" :fullscreen="$vuetify.breakpoint.xsOnly" persistent>
    <v-card>
      <v-toolbar dark :color="color" flat>
        <v-toolbar-title>{{ title }}</v-toolbar-title>
        <v-spacer />
        <v-btn icon dark :title="$t('close')" @click="cancel"><v-icon>close</v-icon></v-btn>
      </v-toolbar>
      <v-card-text class="pt-5 gradient-icons">
        <v-select v-model="code" :items="reasonOptions" :label="$t('quotations.reason.reason')" outlined dense hide-details class="mb-4">
          <template v-slot:prepend><v-icon>mdi-comment-question-outline</v-icon></template>
        </v-select>
        <v-textarea v-model="text" :label="$t('quotations.reason.details')" outlined auto-grow rows="3" hide-details="auto" :rules="[$rules.required]">
          <template v-slot:prepend><v-icon>mdi-text</v-icon></template>
        </v-textarea>
      </v-card-text>
      <v-divider />
      <v-card-actions :class="$vuetify.breakpoint.xsOnly && 'flex-column-reverse'">
        <v-spacer />
        <v-btn :block="$vuetify.breakpoint.xsOnly" text @click="cancel">{{ $t('cancel') }}</v-btn>
        <v-btn :block="$vuetify.breakpoint.xsOnly" :class="$vuetify.breakpoint.xsOnly && 'mb-2'" :color="color" :disabled="!text" @click="confirm">
          {{ $t('quotations.reason.confirm') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
const KINDS = {
  return: { title: 'title_return', color: 'primary', reasons: ['corrections', 'other'] },
  reject: { title: 'title_reject', color: 'error', reasons: ['price', 'schedule', 'competitor', 'other'] },
  cancel: { title: 'title_cancel', color: 'primary', reasons: ['customer_cancelled', 'not_feasible', 'other'] },
};

export default {
  name: 'StatusReasonDialog',
  data() {
    return { dialog: false, kind: 'return', code: null, text: '', resolve: null, titleOverride: null };
  },
  computed: {
    title() {
      return this.titleOverride || this.$t(`quotations.reason.${KINDS[this.kind].title}`);
    },
    color() {
      return KINDS[this.kind].color;
    },
    reasonOptions() {
      return KINDS[this.kind].reasons.map(r => ({ text: this.$t(`quotations.reason.reasons.${r}`), value: r }));
    },
  },
  methods: {
    // Palauttaa Promise<{ code, text } | null>. Syy valitaan aina itse (ei esivalintaa).
    open(kind, titleOverride = null) {
      this.kind = kind;
      this.titleOverride = titleOverride;
      this.code = null;
      this.text = '';
      this.dialog = true;
      return new Promise(resolve => (this.resolve = resolve));
    },
    confirm() {
      this.dialog = false;
      const codeText = this.reasonOptions.find(o => o.value === this.code);
      this.resolve({ code: codeText ? codeText.text : this.code, text: this.text });
    },
    cancel() {
      this.dialog = false;
      this.resolve(null);
    },
  },
};
</script>
